import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';


@Component({
  selector: 'app-invitation-result-dialog',
  templateUrl: './invitation-result-dialog.component.html',
  styleUrls: ['./invitation-result-dialog.component.scss']
})
export class InvitationResultDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
  }

}
